export default __webpack_public_path__ + "static/1940_1950-1e2711f060b9cefe21a1a5179e126b08.mp4";